import React, {useCallback} from "react";
import "./index.scss";
import Title from "features/components/title";
import {__} from "services/i18n";
import {TextField} from "features/components/text-field";
import Button from "features/components/button";
import {Icon} from "features/components/icon";
import {connect} from "react-redux";
import {generateQrCodeStart} from "store/reducer/user/profile/reducer";
import {profileData, profileQrCode} from "store/reducer/user/profile/selectors";
import {b64toBlob} from "services/utils/utils";
import {withToastManager} from "react-toast-notifications";
import { saveAs } from 'file-saver';

/* istanbul ignore next */
const mapStateToProps = state => ({
    qr: profileQrCode(state),
    data: profileData(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    generateQrCodeStart
};

export const PublicProfileBox = (props) => {
    const {data, qr} = props;
    const {generateQrCodeStart} = props;
    const url = `https://${window.location.host}/#/p/${data.slug}`;

    React.useEffect(() => {
        generateQrCodeStart({url});
    }, [url, generateQrCodeStart]);

    const copyLink = useCallback(async () => {
        await navigator.clipboard.writeText(url);
        props.toastManager.add(__("toasts.copied"), { appearance: 'success', id: 'profile-link-copied' });
    }, [props.toastManager, url]);
    /*istanbul ignore next*/
    const copyQr = useCallback(async () => {
        const blob = b64toBlob(qr, 'image/png');
        saveAs(blob, "qr-code.png");
        /*await navigator.clipboard.write([
            // eslint-disable-next-line no-undef
            new ClipboardItem({
                [blob.type]: blob
            })
        ]);*/
        props.toastManager.add(__("toasts.downloaded"), { appearance: 'success', id: 'profile-link-copied' });
    }, [props.toastManager, qr]);

    return <div className="white-box public-profile-box">
        <Title size={20} align={"center"}>{__("public-profile-box.title")}</Title>
        {!qr ? <Icon>loader</Icon> : <img src={qr} alt={"qr code profile"} />}
        <TextField type={"text"} value={url} onChange={() => {}} disabled={true} placeholder={__("public-profile-box.link")} />
        <div className="buttons">
            <Button title={__("buttons.copy-link")} onClick={copyLink} type={"outlined"} size={"small"} />
            <Button title={__("buttons.copy-qr")} onClick={copyQr} type={"outlined"} size={"small"} />
        </div>
    </div>
}
export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(PublicProfileBox));